import React from "react";

function EtcPage() {
  return (
    <div className="projectWrapper">
      {/* article 시작 */}
      <div className="EtcArticle">
        <div className="EtcContent">
          <div className="history">
            <div>
              <h2>2020</h2>
              <ol>
                <li>디어코퍼레이션 입사(2020.6.29)</li>
                <li>Crerar 퇴사(2020.06.26)</li>
                <li>Crerar 입사(2020.04.13)</li>
              </ol>
            </div>
            <div>
              <h2>2019</h2>
              <ol>
                <li>코딩과외시작 - 초등학생,고등학생,직장인 (2019.04.01)</li>
                <li>써밋디자인 퇴사 (2019.03.17)</li>
                <li>배드민턴 동아리 가입 - 플루마 (2019.03.14)</li>
                <li>알고리즘 동아리 가입 - 알프스 (2019.03.11)</li>
              </ol>
            </div>
            <div>
              <h2>2017 ~ 2016</h2>
              <ol>
                <li>써밋디자인 입사 (2017.02.01)</li>
                <li>오투잡,위드몬,크몽 프로그래밍 상품 등록 (2017.07.01)</li>
              </ol>
            </div>
            <div>
              <h2>2015 ~ 2012</h2>
              <ol>
                <li>건국대학교 입학 (2015.03.01)</li>
                <li>홍성고등학교 졸업 (2015.02.01)</li>
                <li>프로그래밍 동아리 창설 - CPU (2014.03.15)</li>
                <li>홍성고등학교 입학 (2012.03.01)</li>
                <li>홍성중학교 졸업 (2012.02.01)</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* article 끝 */}
    </div>
  );
}

export default EtcPage;
